import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ContractError, err, isError, ok } from "@nju/result";
import { ICity, IFetchCitiesResult, IParams } from "./types";
import { serverResponse } from "./validators";

export async function fetchCities({
  postCode,
  query,
  signal,
}: IParams): Promise<IFetchCitiesResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/address/municipalities`,
    {
      signal,
      searchParams: {
        ...(postCode ? { postCode } : {}),
        query,
      },
    },
  );

  if (isError(result)) {
    if (result.err.code !== "REQUEST_ABORTED") {
      Bugsnag.notify(result.err);
    }

    return result;
  }

  const cities = Array.isArray(result.value)
    ? result.value.splice(0, 200)
    : result.value;

  const validated = serverResponse.safeParse(cities);

  if (!validated.success) {
    Bugsnag.notify(validated.error, (event) => {
      event.addMetadata("result", {
        response: result.value,
        query,
      });
    });
    return err(
      new ContractError({
        violations: validated.error,
        extra: {
          where: `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/address/municipalities`,
        },
      }),
    );
  }

  const entries: ICity[] = validated.data.map((city) => {
    return {
      id: city.municipalityId,
      name: city.municipality,
      stateOrProvince: city.stateOrProvince, // województwo
      community: city.community, // gmina
      district: city.district, // powiat
      communityId: city.communityId,
      districtId: city.districtId,
      stateOrProvinceId: city.stateOrProvinceId,
    };
  });

  return ok(entries);
}
